/// 默认的 relay server user name
export const DEFAULT_RELAY_USER = "kdesk1"

/// 默认的 relay server pwd
export const DEFAULT_RELAY_PWD = "kdesk1_Ab"

/// 默认的 relay server port
export const DEFAULT_RELAY_PORT = "3478"

// 未连接到信令服务器
export const ERR_SIGNALING_NOT_CONNECTED = -10000
// Login API 请求失败
export const ERR_LOGIN_API_REQ = -10013

// 获取 deviceSecret 接口请求失败
export const ERR_DEVICESECRET_API_REQ = -10833

// 查询agent在线状态接口请求失败
export const ERR_AGENT_STATUS_API_REQ = -10214
// 获取本地设备 id 失败
export const ERR_GET_DEV_ID = -10249
// 企业登录密码错误
export const ERR_INVALID_KS_LOGIN_PWD = -10058
// 企业登录过期
export const ERR_KS_LOGIN_EXPIRED = -10059
// 个人用户授权过期
export const ERR_PC_EXPIRED = -10060
// 取消企业授权
export const ERR_KS_AUTH_CANCEL = -10061
// 没有设备(账号密码登录)
export const ERR_NO_DEVICE = -10102
// 没有 企业 设备
export const ERR_NO_KC_DEVICE = -10103
// 获取 企业 设备列表 请求失败
export const ERR_GET_DEVICE_API_REQ = -10110

// 获取公钥 请求失败
export const ERR_GET_PUBLIC_KEY_API_REQ = -10451
// 获取出口公网 IP 请求失败（暂不启用）
// export const ERR_GET_WAN_IP_API_REQ = -10134

// 登录页 壁纸设置失败
export const ERR_SET_LOGIN_WALLPAPER = -10502
// 云桌面 壁纸设置失败
export const ERR_APPLY_DESKTOP_WALLPAPER = -10503
// 获取壁纸列表 请求失败
export const ERR_WALLPAPER_API_REQ = -10504

// 云电脑开机失败
export const ERR_DEV_POWER_ON = -10126
// 云电脑关机失败
export const ERR_DEV_POWER_STOP = -10131
// 云电脑重启失败
export const ERR_DEV_POWER_RESTART = -10128

// desktopID以b开头: 移动云（禁用重启/关机功能）
export const ERR_DEV_POWER_STOP_RESUME = -10132
// 获取设备状态请求失败
export const ERR_DEV_API_REQ = -10130
// 获取连接秘钥请求失败
export const ERR_GET_TOKEN_API_REQ = -10200
// agent 不在线
export const ERR_AGENT_OFFLINE = -10201
// 被踢出
export const ERR_KICK_OUT = -10202
// 获取不到显示器
export const ERR_NO_DISPLAYS = -10203
// ICE 错误
export const ERR_ICE = -10204
// 连接设备超时
export const ERR_CONN_TIMEOUT = -10205
// WebRTC diagnostics defined by the client reporting contract.
export const ERR_UNRECV_REMOTE_ICE = -10222
export const ERR_UNRECV_LOCAL_ICE = -10223
export const ERR_UNRECV_ANSWER = -10224
export const ERR_RENDER_TIMEOUT = -10225
// 云电脑内部关机
export const ERR_POWER_OFF = -10206
// 云电脑 agent 重启（对齐 android ErrCode.agentReboot = -10227）
export const ERR_AGENT_REBOOT = -10227
// 本地网络断开并长时间未恢复（对齐 android ErrCode.networkNotRecover = -10226）
export const ERR_NETWORK_NOT_RECOVER = -10226
// 获取不到音视频流
export const ERR_NO_MEDIA_STREAMS = -10213
// 机器状态异常
export const ERR_DEV_STATUS_EXCEPTION = -10127
// 未查询到设备状态
export const ERR_DEV_STATUS_NOT_FOUND = -10129
// 重复的连接
export const ERR_PENDING_CONNECTION = -10210
// 用户未登录
export const ERR_NOT_LOGIN = -10211
// RTC 连接错误
export const ERR_RTC_ERROR = -10207
// 开启麦克风失败
export const ERR_OPEN_MIC = -10216
// 没有麦克风权限
export const ERR_NO_MIC_PERMISSION = -10217
// 没有摄像头权限
export const ERR_NO_CAMERA_PERMISSION = -10218
// 开启摄像头失败
export const ERR_OPEN_CAMERA = -10219

// 获取图片验证码 接口错误
export const ERR_IMGCODE_API_REQ = -10018
// 图片验证码错误 (验证码错误)
export const ERR_CAPTCHA_VERIFY_API_REQ = -10016
// 图片验证码不能为空（密码错误超过5次）
export const ERR_CAPTCHA_NOT_EMPTY = -10017
// 登录失败次数过多，请 5 分钟后再试
export const ERR_LOGIN_TOO_MANY_TIMES = -10001

// 机器欠费锁定
export const ERR_DEV_LOCK = -10104
// 信令鉴权失败(信令token过期)
export const ERR_SIGNALING_AUTH = -10220
// 信令连接失败
export const ERR_SIGNALING_CONNECT_FAILED = -10221

// 设置 企业登录 登录密码 接口错误码
// token已过期
export const SET_PASSWORD_TOKEN_EXPIRED = -10401
// token无效
export const SET_PASSWORD_TOKEN_INVALID = -10402
// token或密码为空
export const SET_PASSWORD_PARAM_EMPTY = -10403
// 用户不存在
export const SET_PASSWORD_USER_NOT_FOUND = -10404
// 密码已设置
export const SET_PASSWORD_ALREADY_SET = -10405
// 设置 企业登录 登录密码 请求失败
export const ERR_SET_KC_PASSWORD_API_REQ = -10406

// 企业授权过期
// ksAuthCode已过期
export const ERR_KS_AUTH_CODE_EXPIRED = -10306
// ksAuthCode无效
export const ERR_KS_AUTH_CODE_INVALID = -10307

// 设置手机号
export const ERR_SET_PHONE_API_REQ = -10008
// 有注册手机号,输入验证码
export const ERR_INPUT_VERIFY_CODE_API_REQ = -10009
// 短信验证码校验失败，60秒后重新发送验证码
export const ERR_VERIFY_CODE_OR_PHONE_FAILED = -10021

// 密码强度太弱，请设置更复杂的密码
export const ERR_WEAK_PASSWORD = -10007

// 登录失败，请检查账号或密码（回到登录页重新输入密码） -10006
export const ERR_ACCOUNT_PASS_ERROR = -10006
// 自动登录凭据/策略错误
export const ERR_LOGIN_TICKET_EXPIRED = -10026
export const ERR_DEVICE_SECRET_UNAVAILABLE = -10027
export const ERR_AUTO_LOGIN_DISABLED_BY_ADMIN = -10028
export const ERR_FACE_LOGIN_DISABLED_BY_ADMIN = -10029

// 摄像头已断开连接（如 USB 摄像头被拔出）
export const ERR_CAMERA_UNMOUNT = -10677

// 获取客户端动态配置失败（对齐 android ErrCode.getClientConfigApiReq）
export const ERR_GET_CLIENT_CONFIG_API_REQ = -10834
// 日志上传失败（对齐 android ErrCode.uploadLogApiReq）
export const ERR_UPLOAD_LOG_API_REQ = -10678
